export default {
    assigned_to_name: "Name",
    assigned_to_username: "Username",
    assigned_to_email: "Email",
    assigned_to_entity_name: "Entity Name"
}